<template>
 <!-- 控除コンポーネント(子) -->
 <div id="holidaywork">
  <p style="margin-bottom: 3px; width: 60px; text-align:center;">
    <span>{{ deducts[index] }}</span>
    <input type="hidden" :value="deduct" />
  </p>
 </div>
</template>

<script>
import moment from 'moment';
import ConstList from './../ConstList';

export default {
  name: 'Deduction',
  data() {
    return {
      deducts: []
    };
  },
  props: {
    monthDay: Array,
    startBasic: Array,
    endBasic: Array,
    breakBasic: Array,
    start: Array,
    end: Array,
    rest: Array,
    attendance1: Array,
    attendance2: Array,
    index: Number
  },
  computed: {
    deduct: function () {
      for (let i = 0; i < this.start.length; i++) {
        const list = this.deducts;

        if (
          this.attendance1[i] === ConstList.HOLIDAY ||
          this.attendance1[i] === ConstList.PAID ||
          this.attendance1[i] === ConstList.SUBSTITUTE ||
          this.attendance1[i] === ConstList.SPECIAL_HOLIDAY
        ) {
          list.splice(i, 1, "");
          continue;
        } 
        
        // 常勤では通常通り残業算出
        if(this.attendance1[i] === ConstList.DEDUCTION){
          // TODO:休日の場合は自社の標準時間を控除（弊社８H）
          list.splice(i, 1, '08:00');
          continue;
        }
        let sTime = moment.duration(this.start[i], 'HH:mm');
        let eTime = moment.duration(this.end[i], 'HH:mm');
        let sBasic;
        let eBasic;
        
        // 午前出勤・午後有給・午後代休・シフトは早退扱いにしない
        if(this.attendance1[i] === ConstList.MORNING_WORK
          || this.attendance2[i] === ConstList.AFTERNOON_PAID
          || this.attendance2[i] === ConstList.AFTERNOON_SUBSTITUTE
          || this.attendance2[i] === ConstList.SHIFT
        ) {
          eBasic = moment.duration(this.end[i], 'HH:mm');
        } else {
          eBasic = moment.duration(this.endBasic[i], 'HH:mm');
        }

        // 午後出勤・午前有給・午前代休・シフトは遅刻扱いにしない
        if(this.attendance2[i] === ConstList.AFTERNOON_WORK
          || this.attendance1[i] === ConstList.MORNING_PAID
          || this.attendance1[i] === ConstList.MORNING_SUBSTITUTE
          || this.attendance2[i] === ConstList.SHIFT
        ) {
          sBasic = moment.duration(this.start[i], 'HH:mm');
        } else {
          sBasic = moment.duration(this.startBasic[i], 'HH:mm');
        }

        // 時間差分設定
        const sDiff = sTime.subtract(sBasic);
        const eDiff = eBasic.subtract(eTime);
        
        // 00:00は空白
        if ((eTime.hours() === 0 && eTime.minutes() === 0) || 
            (sBasic.hours() === 0 && sBasic.minutes() === 0)) {
          list.splice(i, 1, "");
          continue;
        }

        // その他の場合の時間計算
        if (sDiff <= 0 && eDiff > 0) {
          const time = this.formatTime(eDiff);
          list.splice(i, 1, time === '00:00' ? "" : time);
        } else if (eDiff <= 0 && sDiff > 0) {
          const time = this.formatTime(sDiff);
          list.splice(i, 1, time === '00:00' ? "" : time);
        } else {
          const deduct = sDiff.add(eDiff);
          if (deduct.hours() < 0 || deduct.minutes() < 0) {
            list.splice(i, 1, "");
          } else {
            const time = this.formatTime(deduct);
            list.splice(i, 1, time === '00:00' ? "" : time);
          }
        }
      }
      return null;
    }
  },
  watch: {
    deducts: {
      deep: true,
      handler(newVal) {
        this.$emit('updateDeduct', {
          index: this.index,
          value: newVal[this.index]
        });
      }
    }
  },
  methods: {
    formatTime(duration) {
      const hours = duration.hours() < 10 ? '0' + duration.hours() : duration.hours();
      const minutes = duration.minutes() < 10 ? '0' + duration.minutes() : duration.minutes();
      return hours + ':' + minutes;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
